import { render, staticRenderFns } from "./ReenviarCampanha.vue?vue&type=template&id=503482a0&"
import script from "./ReenviarCampanha.vue?vue&type=script&lang=js&"
export * from "./ReenviarCampanha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports